<div class="main-container"> 
  <router-outlet></router-outlet>
</div>